var exports = {
  "v0": "ProfileCardActions.module__iconMedium___QW5oRU",
  "wf": "ProfileCardActions.module__noteButtonContainer___QW5oRU",
  "_b": "ProfileCardActions.module__noteButtonContainerVisible___QW5oRU",
  "VI": "ProfileCardActions.module__noteButton___QW5oRU",
  "lY": "ProfileCardActions.module__noteTooltipContent___QW5oRU",
  "fg": "ProfileCardActions.module__noteIconWrapper___QW5oRU",
  "O8": "ProfileCardActions.module__copyIdButtonContainer___QW5oRU",
  "wG": "ProfileCardActions.module__copyIdButtonContainerVisible___QW5oRU",
  "pm": "ProfileCardActions.module__copyIdButton___QW5oRU",
  "Jt": "ProfileCardActions.module__copyIdIconWrapper___QW5oRU",
};

module.exports = exports;
